/**
 * @file Login Form.
 */

/**
 * Login Form Component.
 */
const vLoginForm = () => {
	const logins = document.querySelectorAll('.v-login-form form');

	if (!logins) {
		return;
	}

	[...logins].forEach((form) => form.addEventListener('submit', (e) => {
		if (form.dataset.type === 'business' && !form.querySelector('[name="_textBoxCompanyId"]').value) {
			e.preventDefault();
			window.location.href = form.dataset.getCompany;
			form.reset();
			return;
		}

		if (form.dataset.override && !localStorage.getItem(`wb_override_${form.dataset.overrideId}`)) {
			e.preventDefault();

			sessionStorage.setItem(`wb-${form.dataset.type}-login-info`, JSON.stringify({
				url:        form.action,
				user_id:    form.querySelector('[name="_textBoxUserId"]').value,
				company_id: form.querySelector('[name="_textBoxCompanyId"]').value,
			}));

			localStorage.setItem(`wb_override_${form.dataset.overrideId}`, 'seen');

			window.location.href = form.dataset.override;
			form.reset();
		}
	}));
};

export default vLoginForm;
